


















































































































import { Component, Mixins, Ref, Watch } from 'vue-property-decorator';
import NoticeBox from '@/components/claim/popup/NoticeBox.vue';
import ClaimProduct from '@/components/claim/popup/ClaimProduct.vue';
import ProductAmountDetail from '@/components/claim/popup/ProductAmountDetail.vue';
import DiscountAndDeliveryRecalculate from '@/components/claim/popup/DiscountAndDeliveryRecalculate.vue';
import RefundAmount from '@/components/claim/popup/CancelPopup/RefundAmount.vue';
import BenefitRecalculate from '@/components/claim/popup/BenefitRecalculate.vue';
import { CancelForm, ClaimClassType, ReasonType, RefundType, ResponsibleObjectType } from '@/types/claim';
import PopupBasic from '@/components/claim/popup/mixins/PopupBasic';
import {
  isCancelRequest,
  isCancelProcRequestRefund,
  isCancelProcWaitingRefund,
} from '@/components/claim/popup/validations';
import { PostOptionCancelsNoPredict, PutOrderCancelsNoRequest, PutOptionCancelsNoRequest } from 'supporter';

@Component({
  components: {
    NoticeBox,
    ClaimProduct,
    ProductAmountDetail,
    DiscountAndDeliveryRecalculate,
    RefundAmount,
    BenefitRecalculate,
  },
  computed: {
    isCancelProcRequestRefund,
    isCancelRequest,
    isCancelProcWaitingRefund,
    showProcWaitingCancelWithdraw() {
      if (this.claimNoResponseData.originalPayType === 'NAVER_PAY') {
        return false;
      }

      return !this.isModifyMode && this.isCancelProcWaitingRefund;
    },
  },
})
export default class CancelPopup extends Mixins(PopupBasic) {
  @Ref('refundAmount')
  private readonly refundAmountComponent!: RefundAmount;
  @Ref('discountAndDeliveryRecalculate')
  private readonly discountAndDeliveryRecalculateComponent!: DiscountAndDeliveryRecalculate;

  private isModifyMode = false; // TODO: 신청기준 마지막 클레임만 [변경]신청이 가능합니다. 스펙아웃
  private cancelPredict: null | PostOptionCancelsNoPredict = null;
  private formData: CancelForm = {
    responsibleObjectType: this.claimNoResponseData.responsibleObjectType as ResponsibleObjectType,
    refundType: this.claimNoResponseData.displayRefundType.refundType as RefundType,
    reasonDetail: this.claimNoResponseData.claimReasonDetail,
    sellerPaysClaimedDelivery: this.claimNoResponseData.sellerPaysClaimedDelivery, // 판매자 부담 여부
    reasonType: this.claimNoResponseData.claimReasonType,
    refundBankAccount: {
      depositorName: '',
      bank: '',
      bankName: '',
      account: '',
    },
  };

  created() {
    this.initFormData();
  }

  private initFormData() {
    const { refundBankAccount } = this.claimNoResponseData;

    this.formData = {
      ...this.formData,
      ...(refundBankAccount && { refundBankAccount }),
    } as any;
  }

  @Watch('formData.returnWayType', { immediate: false })
  private onChangeReturnWayType() {
    this.predictAndResetAmounts();
  }

  @Watch('formData.reasonType', { immediate: false })
  private onChangeReasonType() {
    this.changeResponsibleObjectTypeByRefundType();
    this.changeSellerPaysClaimedDelivery();
    this.predictAndResetAmounts();
  }

  private changeResponsibleObjectTypeByRefundType() {
    switch (this.formData.reasonType) {
      case ReasonType.OTHERS_BUYER:
      case ReasonType.CHANGE_MIND:
        this.formData.responsibleObjectType = ResponsibleObjectType.BUYER;
        return;
    }

    this.formData.responsibleObjectType = ResponsibleObjectType.SELLER;
  }

  private changeSellerPaysClaimedDelivery() {
    this.formData.sellerPaysClaimedDelivery = this.formData.responsibleObjectType === ResponsibleObjectType.SELLER;
  }

  private async predictAndResetAmounts() {
    await this.postOptionCancelsNoPredict();

    this.refundAmountComponent.resetAsPredictedAmounts();
    this.discountAndDeliveryRecalculateComponent.resetAsPredictedAmounts();
  }

  private async postOptionCancelsNoPredict() {
    const { responsibleObjectType, sellerPaysClaimedDelivery } = this.formData;

    const { data } = await this.$api.postOptionCancelsNoPredict({
      pathParams: {
        no: this.$route.query.claimNo.toString(),
      },
      data: {
        responsibleObjectType,
        sellerPaysClaimedDelivery,
      },
    });

    this.cancelPredict = data;
  }

  // 환불처리
  private onCashRefund() {
    if (!confirm(this.$t('CLAIM_POPUP_ASK_REFUND_MESSAGE').toString())) {
      return;
    }
    const { refundType, refundBankAccount } = this.formData;

    const request = {
      pathParams: {
        no: this.$route.query.claimNo.toString(),
      },
      data: {
        refundBankAccount:
          refundType === 'ACCOUNT'
            ? refundBankAccount
            : {
                bankName: null,
                depositorName: null,
                account: null,
                bank: null,
              },
      },
    };

    const apiMap = {
      [ClaimClassType.ORDER_CANCEL]: () => this.$api.putOrderCancelsNoRefundCash(request),
      [ClaimClassType.OPTION_CANCEL]: () => this.$api.putOptionCancelsNoCashRefund(request),
    };

    apiMap[this.claimNoResponseData.claimClassType]().then(() => {
      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'));
      this.onClickClose();
      this.reload();
    });
  }


  private alertMessageForFreeGift() {

    const hasTargetProduct = this.claimNoResponseData.claimedOptions.some(option => (option as any ).isGivenFreeGift);
    if (hasTargetProduct) {
      alert('사은품이 지급된 대상상품이 포함되어있습니다. \n사은품 지급 철회가 필요한 경우 \n사은품 상품도 클레임 처리해 주세요.');
      return;
    }

    const hasFreeGiftProduct = this.claimNoResponseData.claimedOptions.some(option => (option as any).isFreeGift);
    if (hasFreeGiftProduct) {
      alert('사은품 상품이 포함되어 있습니다. \n사은품 지급 대상상품의 클레임 처리가 필요한 경우 \n별도 처리해 주세요.');
    }
  }

  // 취소승인
  private onCancelApprove() {
    this.alertMessageForFreeGift();

    if (!confirm(this.$t('CLAIM_POPUP_ASK_ACCEPT_CANCEL').toString())) {
      return;
    }

    const request = {
      pathParams: {
        no: this.$route.query.claimNo.toString(),
      },
    };

    const apiMap = {
      [ClaimClassType.ORDER_CANCEL]: () => this.$api.putOrderCancelsNoApprove(request),
      [ClaimClassType.OPTION_CANCEL]: () => this.$api.putOptionCancelsNoApprove(request),
    };

    apiMap[this.claimNoResponseData.claimClassType]().then(() => {
      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'));
      this.onClickClose();
      this.reload();
    });
  }

  // 취소신청철회
  private async onWithdraw() {
    const confirmMessage = await this.checkAmountChangeAndGetConfirmMessage();

    if (!confirm(this.$t(confirmMessage).toString())) {
      return;
    }

    const request = {
      pathParams: {
        no: this.$route.query.claimNo.toString(),
      },
    };

    const apiMap = {
      [ClaimClassType.ORDER_CANCEL]: () => this.$api.putOrderCancelsNoWithdraw(request),
      [ClaimClassType.OPTION_CANCEL]: () => this.$api.putOptionCancelsNoWithdraw(request),
    };

    try {
      await apiMap[this.claimNoResponseData.claimClassType]();
      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'));
      this.onClickClose();
      this.reload();
    } catch (e) {}
  }

  // 변경사항저장
  private onModifyCancel() {
    if (!this.validation()) {
      return;
    }

    const request = {
      pathParams: {
        no: this.$route.query.claimNo.toString(),
      },
      data: {
        ...this.formData,
        claimOrderOptions: [],
      },
    };

    const apiMap = {
      [ClaimClassType.ORDER_CANCEL]: () => {
        delete request.data.sellerPaysClaimedDelivery;
        return this.$api.putOrderCancelsNo(request as PutOrderCancelsNoRequest);
      },
      [ClaimClassType.OPTION_CANCEL]: () => this.$api.putOptionCancelsNo(request as PutOptionCancelsNoRequest),
    };

    apiMap[this.claimNoResponseData.claimClassType]().then(() => {
      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'));
      this.isModifyMode = false;
    });
  }

  private validation() {
    const { refundType, refundBankAccount } = this.formData;
    const isAccountEmpty = refundType === 'ACCOUNT' && refundBankAccount.account.trim().length === 0;
    const isDepositerNameEmpty = refundType === 'ACCOUNT' && refundBankAccount.depositorName.trim().length === 0;

    if (isAccountEmpty) {
      alert(this.$t('CLAIM_POPUP_MODIFY_ACCOUNT_VALID_MESSAGE'));
      return false;
    }

    if (isDepositerNameEmpty) {
      alert(this.$t('CLAIM_POPUP_MODIFY_DEPOSITOR_VALID_MESSAGE'));
      return false;
    }

    return true;
  }
}
